// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","xs":"0px","sm":"600px","md":"900px","lg":"1200px","xl":"1536px","container":"noResults_container__YoN_n"};